import { useMemo } from "react";
import { useAppSelector } from "@store";
import { SortDirections } from "app/ApiClient";
import { sortString } from "utils/sortHelper";

export const useNormalizedProjects = (sorting: SortDirections, search?: string) => {
  const { projects } = useAppSelector((state) => state.projectSelector);
  const filteredProjects = useMemo(() => {
    let data = [...projects];

    if (search) {
      const normalizesSearchText = search.toUpperCase();
      data = data.filter(
        (row) =>
          row.upperOriginProjectId.includes(normalizesSearchText) ||
          row.upperProjectName.includes(normalizesSearchText),
      );
    }
    const sortedList = data.sort((a, b) => sortString(a.upperOriginProjectId, b.upperOriginProjectId, sorting));

    return sortedList;
  }, [projects, search, sorting]);
  return {
    projects: filteredProjects,
  };
};
